import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom-v5-compat";

import { useSimpleNavigationCallback } from "seneca-common/utils/hooks/routing";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { useFormatMessage } from "features/localisation";
import SignUpTeacherDetailsForm from "features/sign-up/sign-up-form/components/SignUpFormTeacherDetails";
import { getUserAccountType } from "features/user/selectors";
import { ROUTES } from "routing/routes";

import { createClass } from "../../../teachers/pages/classes-page/modals/CreateClass/actions";
import { isLinkToInvite } from "../../../teachers/routes/links";
import { messages } from "./translations";

type Props = {
  pageNumber: number;
  totalNumberOfPages: number;
  linkToSignUpAccountType: string | null | undefined;
  redirectAuthenticatedUserTo: string | null | undefined;
};

export default function SignUpTeacherDetails({
  redirectAuthenticatedUserTo,
  linkToSignUpAccountType,
  ...other
}: Props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accountType = useSelector(getUserAccountType);
  const [loading, setLoading] = React.useState(false);

  const hasBeenInvitedToClass =
    redirectAuthenticatedUserTo &&
    !!isLinkToInvite(redirectAuthenticatedUserTo);
  const navigateToInviteLink = useSimpleNavigationCallback(
    redirectAuthenticatedUserTo as any
  );

  const formatMessage = useFormatMessage();

  const onBackClick = useSimpleNavigationCallback(
    makeInternalRedirectState({
      pathname: linkToSignUpAccountType as any,
      state: location.state
    } as any) as any
  );

  const onSignUpDetailsComplete = async ({ nickname }: any) => {
    logSignUpEventByAccountType(accountType!);

    if (hasBeenInvitedToClass) {
      navigateToInviteLink();
    } else {
      setLoading(true);

      const className = formatMessage(messages.message, {
        nickname
      });
      const response: any = await dispatch(createClass(className));

      setLoading(false);
      navigate(ROUTES.TEACHER.buildPath({}));
    }
  };

  return (
    // @ts-ignore
    <SignUpTeacherDetailsForm
      {...other}
      onBackClick={onBackClick}
      onExtraSignUpDetailsSuccess={onSignUpDetailsComplete}
      loading={loading}
    />
  );
}
